import {IPlannerPropertyRoom} from "../../types/planner_property/IPlannerPropertyRoom";
import {IPlannerPropertyRoomType} from "../../types/planner_property/IPlannerPropertyRoomType";
import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";
import {isBathroom, isBedroom, isKitchen, isLivingRoom} from "./planner_property_rooms";

const getNormalizedPlannerRoomType = (knownRoomNames: IPlannerRoomNames[], roomType: IPlannerPropertyRoomType, roomName = "") => {
    if (knownRoomNames.includes(IPlannerRoomNames.Kitchen) && isKitchen(roomType)) {
        return IPlannerRoomNames.Kitchen;
    }

    if (knownRoomNames.includes(IPlannerRoomNames.LivingRoom) && isLivingRoom(roomType, roomName)) {
        return IPlannerRoomNames.LivingRoom;
    }

    if (knownRoomNames.includes(IPlannerRoomNames.Bedroom) && isBedroom(roomType, roomName)) {
        return IPlannerRoomNames.Bedroom;
    }

    if (knownRoomNames.includes(IPlannerRoomNames.Bathroom) && isBathroom(roomType)) {
        return IPlannerRoomNames.Bathroom;
    }

    return null;
};

export const normalizePlannerPropertyRoomTypes = (rooms: IPlannerPropertyRoom[], knownRoomNames: IPlannerRoomNames[]) => {
    return rooms.map((room) => {
        return {
            ...room,
            roomTypeNormalized: getNormalizedPlannerRoomType(knownRoomNames, room.room_type, room.name)
        };
    });
};
import {IPlannerPropertyRoom} from "../../types/planner_property/IPlannerPropertyRoom";
import {IPlannerPropertyRoomType} from "../../types/planner_property/IPlannerPropertyRoomType";
import {IPlannerRoomNames} from "../../types/planner_property/IPlannerRoomNames";
import {isBathroom, isBedroom, isKitchen, isLivingRoom} from "./planner_property_rooms";

const getNormalizedPlannerRoomType = (knownRoomNames: IPlannerRoomNames[], roomType: IPlannerPropertyRoomType, roomName = "") => {
    if (knownRoomNames.includes(IPlannerRoomNames.Kitchen) && isKitchen(roomType)) {
        return IPlannerRoomNames.Kitchen;
    }

    if (knownRoomNames.includes(IPlannerRoomNames.LivingRoom) && isLivingRoom(roomType, roomName)) {
        return IPlannerRoomNames.LivingRoom;
    }

    if (knownRoomNames.includes(IPlannerRoomNames.Bedroom) && isBedroom(roomType, roomName)) {
        return IPlannerRoomNames.Bedroom;
    }

    if (knownRoomNames.includes(IPlannerRoomNames.Bathroom) && isBathroom(roomType)) {
        return IPlannerRoomNames.Bathroom;
    }

    return null;
};

export const normalizePlannerPropertyRoomTypes = (rooms: IPlannerPropertyRoom[], knownRoomNames: IPlannerRoomNames[]) => {
    return rooms.map((room) => {
        return {
            ...room,
            roomTypeNormalized: getNormalizedPlannerRoomType(knownRoomNames, room.room_type, room.name)
        };
    });
};
